<template>
  <div :id="id">
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
    />
    <font-awesome-icon
      id="font-awesome-icon-question-circle"
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <portal-target :name="name" slim/>
    <div
      v-if="showEditButton"
      id="show-name"
      class="w-100 edit-mode-background d-flex justify-content-center align-items-center">
        <p class="text-muted">{{ name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    slim: {
      type: Boolean,
      default: true
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ''
    }
  }
}
</script>
